// import UserForm from '../../components/UserForm';
import {
  createInternalUserEndpoint,
  getInternalUsersEndpoint,
  deactivateInternalUserEndpoint,
  activateInternalUserEndpoint,
  updateInternalUserPasswordEndpoint,
} from '../internal-users/services/internalUserService';
import { UserManagerServices } from '../../hooks/useUserManager';
import UserGenericForm from '../../components/UserGenericForm';

const InternalUsersUser = () => {
  const developerServices: UserManagerServices = {
    create: createInternalUserEndpoint,
    list: (_contextId, token) => getInternalUsersEndpoint(token),
    deactivate: deactivateInternalUserEndpoint,
    activate: activateInternalUserEndpoint,
    updatePassword: updateInternalUserPasswordEndpoint,
  };

  return (
    <UserGenericForm
      services={developerServices}
      pageName="Usuarios Internos"
      pageParentName="Usuarios Internos"
      getRolesPath={(userId) =>
        `/internal-users/internalUsers/${userId}/roles-management`
      }
      showPasswordOnReset={false}
    />
  );
};

export default InternalUsersUser;
